import classes from "../../purchase.module.scss";
import { formatMiles, formatMilesDecimalNew } from "@/services/Utils";

import OrdersSaleCodes from "./OrdersSaleCodes";

const OrdersSaleTableBodyDetail = ({ item, _base }) => {
	if (!item.active) {
		return null;
	}

	return (
		<tr className={classes.table_detail}>
			<td colSpan={12} className={classes.td_table}>
				<table className={classes.table_item}>
					<thead>
						<tr className={classes.table_item_tr}>
							<th className={classes.th_detail} style={{ width: "20%" }}>
								Producto
							</th>
							<th className={classes.th_detail} style={{ width: "10%" }}>
								Cant. Envases
							</th>
							<th className={classes.th_detail} style={{ width: "10%" }}>
								Contenido Envase
							</th>
							<th className={classes.th_detail} style={{ width: "10%" }}>
								Contenido Total
							</th>
							<th className={classes.th_detail} style={{ width: "5%" }}>
								U.M
							</th>
							<th className={classes.th_detail} style={{ width: "10%" }}>
								Cant. Recepcionado
							</th>
							<th className={classes.th_detail} style={{ width: "10%" }}>
								% Recepcionado
							</th>
							<th className={classes.th_detail} style={{ width: "10%" }}>
								NC
							</th>
							<th className={classes.th_detail} style={{ width: "10%" }}>
								Códigos
							</th>
						</tr>
					</thead>

					<tbody>
						{item &&
							item.items.map((product, i) => {
								return (
									<tr key={i} className={`${classes.table_item_tr}`}>
										<td className={classes.table_item_td}>
											<div className={`${classes.div_item} ${classes.first_div}`}>{product.product_name}</div>
										</td>
										<td className={classes.table_item_td}>
											<div className={`${classes.div_item}`}>{formatMiles(product.quantity)}</div>
										</td>
										<td className={classes.table_item_td}>
											<div className={`${classes.div_item}`}>{formatMilesDecimalNew(product.container_content)}</div>
										</td>
										<td className={classes.table_item_td}>
											<div className={`${classes.div_item}`}>
												{formatMilesDecimalNew(
													String(
														Number(String(product.quantity).replace(",", ".")) *
															Number(String(product.container_content).replace(",", ".")),
													).replace(".", ","),
												)}
											</div>
										</td>
										<td className={classes.table_item_td}>
											<div className={`${classes.div_item}`}>{product.unit_measurement}</div>
										</td>
										<td className={classes.table_item_td}>
											<div className={`${classes.div_item}`}>{formatMiles(product.quantity_reception)}</div>
										</td>
										<td className={classes.table_item_td}>
											<div
												className={`${classes.div_item}`}
												style={{
													backgroundColor: Number(product.reception) < 100 ? "#ff030359" : "#05930059",
													color: Number(product.reception) < 100 ? "red" : "green",
												}}
											>
												{Math.min(Number(product.reception), 100) === 100
													? 100
													: formatMilesDecimalNew(String(Math.min(Number(product.reception), 100)).replace(".", ","))}
												%
											</div>
										</td>
										<td className={classes.table_item_td}>
											<div className={`${classes.div_item}`}>
												{product.orders_return &&
													product.orders_return.map((or, k) => {
														return (
															<span key={k}>
																NC°{" "}
																<a href={`/nota_credito/editar/${or.code}`} target="_blank" rel="noopener noreferrer">
																	{or.code}
																</a>
															</span>
														);
													})}
											</div>
										</td>
										<td className={classes.table_item_td}>
											<div className={`${classes.div_item} ${classes.last_div}`}>
												<>
													{product.inventories.length !== 0 ? (
														<OrdersSaleCodes product={product} />
													) : (
														<div className={classes.button_generate_tags}>Sin códigos asociados</div>
													)}
												</>
											</div>
										</td>
									</tr>
								);
							})}
					</tbody>
				</table>
			</td>
		</tr>
	);
};

export default OrdersSaleTableBodyDetail;
